import { FC } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import DropdownMenuItem from 'src/components/ui/atoms/DropdownMenuItem'
import UserIcon from 'src/components/ui/atoms/Icons/UserIcon'
import useAccount from 'src/hooks/useAccount'
import { isUserAdminFn } from 'src/utils/userUtils'

const LINK = '/administration'

const AdministrationMenu: FC = () => {
  const { informations } = useAccount()
  const isAdmin = isUserAdminFn(informations)
  const { pathname } = useLocation()

  if (!isAdmin) {
    return null
  }

  const isActive = pathname === LINK
  return (
    <NavLink to={LINK}>
      <DropdownMenuItem
        icon={<UserIcon width={undefined} height={undefined} className="size-4" />}
        label="Administration"
        data-testid="settings-menu-administration"
        active={isActive}
        classes={{
          icon: 'text-hit-gray',
          activeIcon: 'text-inherit',
        }}
      />
    </NavLink>
  )
}

export default AdministrationMenu
